import { Component, OnInit, ViewChild } from '@angular/core';
import { Storage } from '@ionic/storage';
import { App, NavController, NavParams, ToastController, ViewController } from 'ionic-angular';

import { SignaturePad } from 'angular2-signaturepad';
import { AuthProvider } from '../../../../providers/auth/auth';
import { EmployeeRhProvider } from '../../../../providers/employeerh/employeerh';


@Component({
  selector: 'page-rh-custom-interview',
  templateUrl: 'rh-custominterview.html',
})
export class RhCustomInterview implements OnInit {

  interview: any = null;
  process: any = null;
  questions: any = [];
  step: number = 0;
  answers: any = {};
  isManager: boolean = false;
  signature: string = null;

  // Goals
  hasFilledGoals: boolean = false;
  goals: any[] = [];
  storeGoalAnswers: any = {};

  // Goals next year
  showNotice: boolean = true;
  goalsNextYear: any[] = [];
  nextYearGoalsSaved = false;


  @ViewChild(SignaturePad) signaturePad: SignaturePad;

  private signaturePadOptions: Object = { // passed through to szimek/signature_pad constructor
    'minWidth': 5,
    'canvasWidth': 500,
    'canvasHeight': 300,
    'dotSize': 0.3
  };

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public storageProvider: Storage,
    public app: App,
    public authProvider: AuthProvider,
    public employeeRhProvider: EmployeeRhProvider,
    public viewCtrl: ViewController,
    public toastCtrl: ToastController
  ) {
    this.process = this.navParams.get('interview');
    this.isManager = this.navParams.get('isManager');
    this.interview = this.process.Interview;
    this.goals = this.navParams.get('goals');
  }

  ngOnInit() {
    this.loadDatas();
  }

  drawComplete() {
    this.signature = this.signaturePad.toDataURL();
  }

  clearCanvas() {
    this.signaturePad.clear();
    this.signature = null;
  }

  async loadDatas() {
    // init goals
    for (let goal of this.goals) {
      this.storeGoalAnswers[goal.id] = {
        goal_id: goal.id,
        value_reached: null,
        value_comment: null
      }
    }
    // check if localstorage goals exist for this interview
    let localStorageGoals = await this.storageProvider.get(`prhci_goals${this.interview.id}`);
    if (localStorageGoals) {
      this.storeGoalAnswers = localStorageGoals;
    }

    // Init next year goals
    if (this.process.step == 2) {
      this.addGoalNextYear()
    }


    this.interview.Sets = this.interview.Sets.sort(this.compare)
    for (let set of this.interview.Sets) {
      set.QuestionSets.Questions = set.QuestionSets.Questions.sort(this.compare)
    }
    for (let set of this.interview.Sets) {
      let category = set.QuestionSets
      this.questions.push({ category_title: category.title, questions: category.Questions })
      for (let question of category.Questions) {
        this.answers[question.id] = {
          question_id: question.id,
          option: '',
          string: '',
          answer_number: null,
          type: question.type
        };
      }
    }

    // check if localstorage answers exist for this interview
    let localStorageAnswers = await this.storageProvider.get(`prhci_qa${this.interview.id}`);
    if (localStorageAnswers) {
      this.answers = localStorageAnswers;
    }
  }

  checkHandle(currQuestionId, currOption) {
    this.answers[currQuestionId].option = currOption.option;
  }

  checkHandleStars(currQuestionId, currOption) {
    this.answers[currQuestionId].answer_number = currOption;
    this.answers[currQuestionId].option = currOption;
  }

  changeStep(direction) {
    switch (direction) {
      case 'less':
        this.step -= 1;
        break;

      case 'more':
        this.step += 1;
        break;

      default:
        break;
    }

    // Save answers in localstorage to avoid losing answers
    this.storageProvider.set(`prhci_qa${this.interview.id}`, this.answers);
  }

  submitSurvey() {

    if (this.process.step == 2 && this.nextYearGoalsSaved == false) {
      let toast = this.toastCtrl.create({ message: "Vous devez renseigner et valider les nouveaux objectifs", duration: 6000, position: 'bottom' });
      toast.present();
      return;
    }

    if (this.process.step == 2 && this.signature == null) {
      let toast = this.toastCtrl.create({ message: "Vous devez signer l'entretien", duration: 6000, position: 'bottom' });
      toast.present();
      return;
    }

    let answers = this.answers;
    let payloadAnswers = [];
    Object.keys(answers).forEach(function (key) {
      payloadAnswers.push(answers[key])
    })

    // Goals handle
    const goals = this.storeGoalAnswers;
    let goalAnswers = [];
    for (var key in goals) {
      goalAnswers.push(goals[key])
    }

    let payload = { interview_id: this.interview.id, process_id: this.process.id, answers: payloadAnswers, signature: this.signature, goals: goalAnswers, nextYearGoals: this.goalsNextYear }

    this.employeeRhProvider.saveUserCustomInterview(payload).subscribe((res) => {
      if (res.success) {
        // Remove state from localstorage
        this.storageProvider.remove(`prhci_qa${this.interview.id}`);
        this.storageProvider.remove(`prhci_goals${this.interview.id}`);
        // Close and toast
        let toast = this.toastCtrl.create({ message: "Vos réponses ont été envoyées", duration: 6000, position: 'bottom' });
        toast.present();
        this.dismiss();
      }
    })

  }

  setRangeAnswer(question, answer) {
    switch (answer) {
      case 1:
        question.string = "Pas du tout d'accord";
        break;

      case 2:
        question.string = "Pas d'accord";
        break;

      case 3:
        question.string = "Moyennement d'accord";
        break;

      case 4:
        question.string = "D'accord";
        break;

      case 5:
        question.string = "Absolument d'accord";
        break;

      default:
        break;
    }
  }

  // Goals
  setGoalRadioAnswer(goalId, value) {
    this.storeGoalAnswers[goalId].value_reached = value
  }

  confirmGoals() {
    this.hasFilledGoals = true;
    this.storageProvider.set(`prhci_goals${this.interview.id}`, this.storeGoalAnswers);
  }

  getGoalValue(value) {
    switch (value) {
      case 0:
        return 'Non'

      case 1:
        return 'En partie'

      case 2:
        return 'Oui'

      default:
        break;
    }
  }

  // Next Year Goals
  addGoalNextYear() {
    this.goalsNextYear.push({
      name: null,
      period: null,
      goal_date: new Date().toISOString(),
      percent: null,
    })
  }

  deleteGoalNextYear(index) {
    this.goalsNextYear.splice(index, 1)
  }

  setUnderstoodNotice() {
    this.showNotice = false;
  }

  checkSubmitValues(goal) {
    if (
      goal.name == null ||
      goal.period == null ||
      goal.percent_value == null
    ) {
      return false;
    } else {
      return true;
    }
  }
  saveNextYearGoals() {
    let totalPonderation = 0;
    let hasMissingValue = false;
    let hasInvalidPonderation = false;
    for (let goal of this.goalsNextYear) {
      totalPonderation += +goal.percent_value;
      if (!this.checkSubmitValues(goal)) {
        hasMissingValue = true;
        let toast = this.toastCtrl.create({ message: "Erreur : certains champs sont incomplets", duration: 6000, position: 'top' });
        toast.present();
        return;
      }
    }
    if (totalPonderation !== 100) {
      hasInvalidPonderation = true;
      let toast = this.toastCtrl.create({ message: "Erreur : le total de pondération doit être de 100% et non de " + totalPonderation + "%", duration: 6000, position: 'top' });
      toast.present();
    }
    if (!hasMissingValue && !hasInvalidPonderation) {
      this.nextYearGoalsSaved = true;
    }
  }


  // Modal ctrl
  dismiss() {
    this.viewCtrl.dismiss();
  }

  // Utils
  compare(a, b) {
    if (a.orderNumber < b.orderNumber) {
      return -1;
    }
    if (a.orderNumber > b.orderNumber) {
      return 1;
    }
    return 0;
  }


}



// WEBPACK FOOTER //
// ./src/pages/employee/_rh/rh-custominterview/rh-custominterview.ts